import loginImg from "../assets/Images/login.png"
import Template from "../components/core/Auth/Template"

function Login() {
  return (
    <Template
      title="Welcome Back"
      description1="Train your dog for today, tomorrow, and beyond."
      description2="Make you Dog Obedient."
      image={loginImg}
      formType="login"
    />
  )
}

export default Login
